import { FocusScope } from '@react-aria/focus';
import { DismissButton, useOverlay } from '@react-aria/overlays';
import * as React from 'react';

interface PopoverProps extends React.PropsWithChildren {
  className?: string;
  isOpen?: boolean;
  popoverRef?: React.RefObject<HTMLDivElement>;

  onClose: () => void;
}

export const Popover = (props: PopoverProps) => {
  let ref = React.useRef<HTMLDivElement>(null);
  let { popoverRef = ref, isOpen, onClose, children, className } = props;
  let { overlayProps } = useOverlay(
    {
      isOpen,
      onClose,
      shouldCloseOnBlur: true,
      isDismissable: false
    },
    popoverRef
  );

  return (
    <FocusScope restoreFocus>
      <div {...overlayProps} ref={popoverRef} className={className}>
        {children}
        <DismissButton onDismiss={onClose} />
      </div>
    </FocusScope>
  );
};

export default Popover;
